/**
 * Course Data Constants - Single Source of Truth
 * 
 * Update this file when labs are added/removed.
 * All components will automatically reflect the changes.
 * 
 * Future: Can be converted to API-based dynamic loading
 */

export const COURSE_DATA = {
  // =========================================================================
  // LINUX COURSES - ₹999 / $45
  // =========================================================================
  RH124: {
    code: 'RH124',
    name: 'Linux Fundamentals',
    fullName: 'RH124 - Linux Fundamentals',
    labs: 42,
    freeLabs: 3,
    price: 999,
    priceUSD: 45,
    icon: '🚀',
    color: 'red',
    level: 'Foundation',
    description: 'Master the fundamentals of Linux system administration',
    certification: 'RHCSA Part 1',
    category: 'linux'
  },
  RH134: {
    code: 'RH134',
    name: 'Linux Administration',
    fullName: 'RH134 - Linux Administration',
    labs: 18,
    freeLabs: 0,
    price: 999,
    priceUSD: 45,
    icon: '⚡',
    color: 'red',
    level: 'Advanced',
    description: 'Advanced Linux system administration for RHCSA certification',
    certification: 'RHCSA Part 2',
    category: 'linux'
  },
  
  // =========================================================================
  // DEVOPS COURSES - ₹799 / $35
  // =========================================================================
  SVRADM: {
    code: 'SVRADM',
    name: 'Server Administration',
    fullName: 'SVRADM - Server Administration',
    labs: 15,
    freeLabs: 0,
    price: 799,
    priceUSD: 35,
    icon: '🖥️',
    color: 'purple',
    level: 'Professional',
    description: 'Master Linux server services - SSH, DNS, Web, NFS, Samba, FTP, MariaDB, Postfix, Firewalld, Rsyslog & Dovecot',
    prerequisite: 'RHCSA',
    category: 'devops'
  },
  ANSIBLE: {
    code: 'ANSIBLE',
    name: 'RHCE/Automation',
    fullName: 'ANSIBLE - RHCE/Automation',
    labs: 18,
    freeLabs: 0,
    price: 799,
    priceUSD: 35,
    icon: '🤖',
    color: 'gray',
    level: 'Professional',
    description: 'Master Ansible automation - Playbooks, Roles, Jinja2 Templates, Inventory Management, Handlers & More',
    prerequisite: 'RHCSA',
    certification: 'RHCE',
    category: 'devops'
  },
  DOCKER: {
    code: 'DOCKER',
    name: 'Containers',
    fullName: 'DOCKER - Containers',
    labs: 18,
    freeLabs: 0,
    price: 799,
    priceUSD: 35,
    icon: '🐳',
    color: 'blue',
    level: 'Professional',
    description: 'Master Docker containers - Images, Volumes, Networks, Compose & Real-world Projects',
    prerequisite: 'RHCSA',
    category: 'devops'
  },
  TERRAFORM: {
    code: 'TERRAFORM',
    name: 'Infrastructure as Code',
    fullName: 'TERRAFORM - Infrastructure as Code',
    labs: 18,
    freeLabs: 0,
    price: 799,
    priceUSD: 35,
    icon: '🏗️',
    color: 'violet',
    level: 'Professional',
    description: 'Master Terraform - AWS Infrastructure, Modules, State Management & Real-world Projects',
    prerequisite: 'RHCSA',
    isCloudCourse: false,
    category: 'devops',
    selfVerifyTasks: {
      lab3: ['q5', 'q6'],
      lab7: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab8: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab9: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab10: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab11: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab14: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab16: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab17: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
      lab18: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6']
    }
  },
  KUBERNETES: {
    code: 'KUBERNETES',
    name: 'Container Orchestration',
    fullName: 'KUBERNETES - Container Orchestration (k3s)',
    labs: 18,
    freeLabs: 0,
    price: 799,
    priceUSD: 35,
    icon: '⎈',
    color: 'blue',
    level: 'Professional',
    description: 'Master Kubernetes with k3s - Pods, Deployments, Services, Ingress, Helm, RBAC & Full Stack Projects',
    prerequisite: 'Docker',
    category: 'devops',
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg'
  },
  
  // =========================================================================
  // BASIC COURSES - ₹499 / $19
  // =========================================================================
  GIT: {
    code: 'GIT',
    name: 'Version Control',
    fullName: 'GIT - Version Control & GitHub',
    labs: 18,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '📚',
    color: 'orange',
    level: 'Beginner',
    description: 'Master Git & GitHub - Branching, Merging, Pull Requests & Real-world Collaboration',
    prerequisite: null,
    category: 'basic'
  },
  EXAM_RHCSA: {
    code: 'EXAM_RHCSA',
    name: 'RHCSA Exam Practice',
    fullName: 'RHCSA Practice Exam',
    labs: 3,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '🎯',
    color: 'red',
    level: 'Exam',
    description: '3 Complete RHCSA Practice Exams with Real VM-based Labs and Auto Verification',
    prerequisite: 'RHCSA',
    certification: 'RHCSA Exam Prep',
    isExamCourse: true,
    category: 'basic'
  },
  EXAM_DO188: {
    code: 'EXAM_DO188',
    name: 'DO188 Container Exam',
    fullName: 'DO188 Container Practice Exam',
    labs: 3,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '🐳',
    color: 'blue',
    level: 'Exam',
    description: '3 Complete DO188 Container Practice Exams with Podman, Buildah & Container Registry',
    prerequisite: 'Docker/Containers',
    certification: 'DO188 Exam Prep',
    isExamCourse: true,
    category: 'basic'
  },
  EXAM_EX294: {
    code: 'EXAM_EX294',
    name: 'EX294 Ansible Exam',
    fullName: 'EX294 Ansible Practice Exam',
    labs: 3,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '🔧',
    color: 'gray',
    level: 'Exam',
    description: '3 Complete EX294 Ansible Practice Exams with Playbooks, Roles, Vault & System Roles',
    prerequisite: 'Ansible Basics',
    certification: 'EX294/RHCE Exam Prep',
    isExamCourse: true,
    category: 'basic'
  },
  
  // =========================================================================
  // PROGRAMMING COURSES - ₹499 / $19
  // =========================================================================
  PYTHON: {
    code: 'PYTHON',
    name: 'Python Programming',
    fullName: 'Python - Programming Fundamentals to Advanced',
    labs: 15,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '🐍',
    color: 'yellow',
    level: 'Beginner to Advanced',
    description: 'Master Python programming from basics to advanced - Variables, Functions, OOP, File I/O, Data Structures & Projects',
    prerequisite: null,
    isProgrammingCourse: true,
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg',
    category: 'programming'
  },
  C_LANG: {
    code: 'C_LANG',
    name: 'C Programming',
    fullName: 'C - Programming Fundamentals',
    labs: 15,
    freeLabs: 2,
    price: 499,
    priceUSD: 19,
    icon: '💻',
    color: 'blue',
    level: 'Beginner to Advanced',
    description: 'Master C programming - Variables, Pointers, Arrays, Strings, Structures, File I/O & Memory Management',
    prerequisite: null,
    isProgrammingCourse: true,
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg',
    category: 'programming'
  },
  CPP: {
    code: 'CPP',
    name: 'C++ Programming',
    fullName: 'C++ - Object Oriented Programming',
    labs: 15,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '⚡',
    color: 'indigo',
    level: 'Beginner to Advanced',
    description: 'Master C++ programming - OOP Concepts, Classes, Inheritance, Polymorphism, STL & Modern C++ Features',
    prerequisite: 'C Programming (Recommended)',
    isProgrammingCourse: true,
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg',
    category: 'programming'
  },

  // =========================================================================
  // DATABASE COURSES - ₹499 / $19
  // =========================================================================
  MYSQL: {
    code: 'MYSQL',
    name: 'MySQL/MariaDB',
    fullName: 'MySQL/MariaDB - Database Administration',
    labs: 15,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '🗄️',
    color: 'orange',
    level: 'Beginner to Advanced',
    description: 'Master MySQL/MariaDB - Installation, CRUD, JOINs, Indexes, Stored Procedures, Triggers, Backup & Security',
    prerequisite: null,
    isDatabaseCourse: true,
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg',
    category: 'database'
  },

  // =========================================================================
  // JAVA COURSE - ₹499 / $19
  // =========================================================================
  JAVA: {
    code: 'JAVA',
    name: 'Core Java',
    fullName: 'Core Java - Zero to Hero',
    labs: 15,
    freeLabs: 0,
    price: 499,
    priceUSD: 19,
    icon: '☕',
    color: 'red',
    level: 'Beginner to Advanced',
    description: 'Master Core Java - OOP, Collections, File I/O, Multithreading, JDBC & Build Real Projects',
    prerequisite: null,
    isProgrammingCourse: true,
    logo: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg',
    category: 'programming'
  }
};

// All Access EXCLUDES only mock tests & projects (business rule).
// INCLUDES: all courses + 3 exam attempts (RHCSA, DO188, EX294).
// Backend mirrors this set + the PROJECT_ prefix in payments.py
// (is_inside_all_access). Keep this list in sync if you ever change either.
export const ALL_ACCESS_EXCLUDED = new Set(['MOCK_TESTS', 'PROJECTS_ACCESS']);

/**
 * Single source of truth on the frontend: is this SKU part of the
 * All Access bundle? Mirrors backend's is_inside_all_access().
 * Mock Tests + Projects (umbrella PROJECTS_ACCESS + individual PROJECT_<id>)
 * are sold à la carte even to All Access subscribers.
 */
export const isInsideAllAccess = (courseId) => {
  if (!courseId) return false;
  if (ALL_ACCESS_EXCLUDED.has(courseId)) return false;
  if (typeof courseId === 'string' && courseId.startsWith('PROJECT_')) return false;
  return true;
};

// =========================================================================
// ALL ACCESS - ₹4999 (Single Bundle - Replaces all old bundles)
// IMPORTANT: Exam labs (EXAM_RHCSA, EXAM_DO188, EXAM_EX294) are included.
// Mock Tests and Projects (PROJECTS_ACCESS / PROJECT_*) are not included.
// =========================================================================
export const ALL_ACCESS = {
  code: 'ALL_ACCESS',
  name: 'All Access - Lifetime',
  price: 4999,
  price_usd: 149,
  max_credit: 3000,
  min_payment: 1999,
  icon: '👑',
  get courses() {
    return Object.keys(COURSE_DATA).filter(c => !ALL_ACCESS_EXCLUDED.has(c));
  },
  get labs() {
    return Object.entries(COURSE_DATA)
      .filter(([c]) => !ALL_ACCESS_EXCLUDED.has(c))
      .reduce((sum, [, course]) => sum + course.labs, 0);
  },
  get description() {
    return `Lifetime access to ${this.courses.length} courses (${this.labs} labs) — excludes mock tests & projects`;
  }
};

// Legacy export for backward compatibility (will be removed)
export const BUNDLE_DATA = {
  ALL_ACCESS: ALL_ACCESS
};

// =============================================================================
// SIMPLIFIED PRICING STRUCTURE (2025)
// Single source of truth for all pricing - matches backend EXACTLY
// =============================================================================

export const PRICING = {
  // Category-based pricing tiers
  categories: {
    programming: { 
      price_inr: 499, 
      price_usd: 19, 
      courses: ['C_LANG', 'CPP', 'PYTHON', 'JAVA'] 
    },
    basic: { 
      price_inr: 499, 
      price_usd: 19, 
      courses: ['GIT', 'EXAM_RHCSA', 'EXAM_DO188', 'EXAM_EX294', 'MOCK_TESTS'] 
    },
    devops: { 
      price_inr: 799, 
      price_usd: 35, 
      courses: ['SVRADM', 'DOCKER', 'ANSIBLE', 'TERRAFORM', 'KUBERNETES'] 
    },
    linux: { 
      price_inr: 999, 
      price_usd: 45, 
      courses: ['RH124', 'RH134'] 
    },
    database: {
      price_inr: 499,
      price_usd: 19,
      courses: ['MYSQL']
    }
  },
  
  // All Access Bundle - THE ONLY BUNDLE
  allAccess: {
    code: 'ALL_ACCESS',
    price_inr: 4999,
    price_usd: 149,
    max_credit_inr: 3000,
    min_payment_inr: 1999,
    description: 'Lifetime access to ALL courses - Best Value!'
  },
  
  // USD to INR rate for reference
  usd_to_inr: 90,

  // Projects Access
  projectsAccess: {
    code: 'PROJECTS_ACCESS',
    price_inr: 999,
    price_usd: 11,
    description: 'Access all real-world projects with step-by-step guides'
  }
};

// Get course price from COURSE_DATA (source of truth)
export const getCoursePrice = (courseCode) => {
  const course = COURSE_DATA[courseCode];
  if (!course) {
    return { inr: 999, usd: 45, category: 'unknown' };
  }
  
  // Find category for USD pricing
  for (const [category, data] of Object.entries(PRICING.categories)) {
    if (data.courses.includes(courseCode)) {
      return { 
        inr: course.price, 
        usd: data.price_usd, 
        category 
      };
    }
  }
  return { inr: course.price, usd: 45, category: course.category || 'default' };
};

// Calculate All Access price with credit for existing customers
export const getAllAccessPrice = (totalPaidInr = 0) => {
  const credit = Math.min(totalPaidInr, PRICING.allAccess.max_credit_inr);
  const finalPrice = Math.max(
    PRICING.allAccess.price_inr - credit,
    PRICING.allAccess.min_payment_inr
  );
  return {
    base_price: PRICING.allAccess.price_inr,
    credit: credit,
    final_price: finalPrice,
    savings: credit
  };
};

// Get total value of all individual courses
export const getTotalCoursesValue = () => {
  return Object.values(COURSE_DATA).reduce((sum, course) => sum + course.price, 0);
};

// Helper functions
export const getTotalLabs = (courseIds) => {
  return courseIds.reduce((total, id) => {
    return total + (COURSE_DATA[id]?.labs || 0);
  }, 0);
};

export const getRHCSALabs = () => getTotalLabs(['RH124', 'RH134']);
export const getAllCoursesLabs = () => getTotalLabs(['RH124', 'RH134', 'SVRADM', 'ANSIBLE', 'DOCKER', 'TERRAFORM', 'GIT']);

export const formatLabsText = (courseId) => {
  const course = COURSE_DATA[courseId];
  if (!course) return '';
  return `${course.labs} ${course.labs === 1 ? 'lab' : 'labs'}`;
};

export const getCourseWithLabs = (courseId) => {
  const course = COURSE_DATA[courseId];
  if (!course) return courseId;
  return `${course.fullName} (${course.labs} labs)`;
};
